export const data3 = [
    {
        hash: "DS101",
        name: "Prakhar Jain",
        fullName: "Prakhar Jain",
        email: "gamingzone3105@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "DS102",
        name: "Tarun Marskolhe",
        fullName: "TARUN MARSKOLHE",
        email: "tarunmarskolhe2004@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "DS103",
        name: "Joy Vithayathil",
        fullName: "Joy Vithayathil",
        email: "joyvithayathiltftofficial@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "DS104",
        name: "Sai Rohith",
        fullName: "Sai Rohith",
        email: "sairohith685@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "DS105",
        name: "Mehejabee Pathan",
        fullName: "MEHEJABEE PATHAN",
        email: "pathan.mehejabee37@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "DS106",
        name: "Jesly Joji",
        fullName: "Jesly Joji",
        email: "jeslyjoji2003@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "DS107",
        name: "Anish Makhija",
        fullName: "Anish Makhija",
        email: "anishmakhija61@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "DS108",
        name: "Daksh Mittal",
        fullName: "Daksh Mittal",
        email: "dakshmittal.8585@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "DS109",
        name: "Jaffer Siddiq Khan",
        fullName: "Jaffer siddiq khan",
        email: "Jaffersiddiqkhan@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "DS110",
        name: "Vedanshi Mishra",
        fullName: "Vedanshi Mishra",
        email: "vedanshi.mishrait2021@indoreinstitute.com",
        domain: "Data Science"
    },
    {
        hash: "DS111",
        name: "Prerita Bhokardankar",
        fullName: "Prerita Bhokardankar",
        email: "preritabhk@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "DS112",
        name: "Manushree Atre",
        fullName: "Manushree Atre",
        email: "atremanushree18@gmail.com",
        domain: "Data Science"
    },
    {
        hash: "WD101",
        name: "Aayush Dushane",
        fullName: "Aayush Dushane",
        email: "aayushdushane02@gmail.com",
        domain: "Web Development"
    },
    {
        hash: "WD102",
        name: "Harshita Maywade",
        fullName: "Harshita Maywade",
        email: "harshitamaywade@gmail.com",
        domain: "Web Development"
    },
    {
        hash: "WD103",
        name: "Khushi Rathore",
        fullName: "Khushi Rathore",
        email: "22btc035@ietdavv.edu.com",
        domain: "Web Development"
    },
    {
        hash: "WD104",
        name: "Arin Jain",
        fullName: "Arin Jain",
        email: "arinj0788@gmail.com",
        domain: "Web Development"
    },
    {
        hash: "WD105",
        name: "Harshit Jain",
        fullName: "Harshit Jain",
        email: "harshitjain.shr@gmail.com",
        domain: "Web Development"
    },
    {
        hash: "WD106",
        name: "Rohit Kumar Kushwaha",
        fullName: "Rohit Kumar Kushwaha",
        email: "rohitmaurya8205@gmail.com",
        domain: "Web Development"
    },
    {
        hash: "WD107",
        name: "Akhil Dhanesh",
        fullName: "Akhil Dhanesh",
        email: "akhildhanesh965636@gmail.com",
        domain: "Web Development"
    },
    {
        hash: "WD108",
        name: "Kritika Dua",
        fullName: "KRITIKA DUA",
        email: "duakritika606@gmail.com",
        domain: "Web Development"
    },
    {
        hash: "WD109",
        name: "Suyash Vishwakarma",
        fullName: "Suyash Vishwakarma",
        email: "sanvishw.0080@gmail.com",
        domain: "Web Development"
    },
    {
        hash: "WD110",
        name: "Avni Pagaria",
        fullName: "Avni Pagaria",
        email: "avnipagaria999@gmail.com",
        domain: "Web Development"
    },
    {
        hash: "WD111",
        name: "Jamila Bagwala",
        fullName: "Jamila Bagwala",
        email: "jamilabw786@gmail.com",
        domain: "Web Development"
    },
    {
        hash: "WD112",
        name: "Ramya H Kallangoudar",
        fullName: "Ramya H Kallangoudar",
        email: "hkramya18@gmail.com",
        domain: "Web Development"
    }
]